import { ConditionalLink } from '@natu/ui/ConditionalLink';
import { getSlugWithDash } from '@natu/utils/getSlugWithDash';

import { ArticleNodeCategory } from '../../../../../../utils/src/types/Blog/ArticleNode.types';

interface ArticleCategoryTagProps {
  category: ArticleNodeCategory;
}

export const ArticleCategoryTag = ({ category }: ArticleCategoryTagProps) => {
  const { full_slug, content } = category;

  return (
    <ConditionalLink href={getSlugWithDash(full_slug)}>
      <span className="inline-block rounded-2xl border border-gray-200 bg-gray-50 px-2 py-0.5 text-xs text-gray-700">
        {content?.name}
      </span>
    </ConditionalLink>
  );
};
